import { uiRouterComponent } from '@mode/workspace-settings/feature-members-angularjs';
import { IdentityComponent } from './identity.component';
import { IdentityService } from './identity.service';

export const IdentityRoutesConfig = [
  '$stateProvider',
  ($stateProvider) => {
    $stateProvider.state({
      name: 'org-settings.identity',
      url: `/identity_providers`,
      ...uiRouterComponent(IdentityComponent),
      resolve: {
        organization: ['IdentityService', (identityService: IdentityService) => identityService.getOrgWithProviders()],
      },
    });
  },
];
